import React from 'react';

const THX_RED = '#B71530';

export default function PaginationFooter({ page, totalPages, total, pageSize, onPageChange, onPageSizeChange }) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to   = Math.min(page * pageSize, total);

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 2)
    .reduce((acc, p, i, arr) => {
      if (i > 0 && p - arr[i - 1] > 1) acc.push('...');
      acc.push(p);
      return acc;
    }, []);

  return (
    <div className="card-footer py-2 d-flex justify-content-between align-items-center" style={{ fontSize: '13px' }}>
      <div className="d-flex align-items-center gap-2">
        <label className="mb-0 text-muted">Show</label>
        <select className="form-select form-select-sm" style={{ width: 'auto' }} value={pageSize} onChange={onPageSizeChange}>
          <option value={10}>10 records</option>
          <option value={25}>25 records</option>
          <option value={50}>50 records</option>
          <option value={100}>100 records</option>
        </select>
        {total > 0 && <span className="text-muted">{from}–{to} of {total}</span>}
      </div>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(1)}>&laquo;</button>
          </li>
          <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(page - 1)}>&lsaquo;</button>
          </li>
          {pages.map((p, i) => p === '...'
            ? <li key={`e${i}`} className="page-item disabled"><span className="page-link">…</span></li>
            : <li key={p} className={`page-item ${p === page ? 'active' : ''}`}>
                <button
                  className="page-link"
                  style={p === page ? { backgroundColor: THX_RED, borderColor: THX_RED } : {}}
                  onClick={() => onPageChange(p)}
                >{p}</button>
              </li>
          )}
          <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(page + 1)}>&rsaquo;</button>
          </li>
          <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(totalPages)}>&raquo;</button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
